var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgL11 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.00 0.00 360.00 455.00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(-3375.00, 0.00)",
    id: "L11_Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3382.64,156.00 C3380.66,161.78 3378.66,176.15 3378.82,183.47 C3379.02,190.85 3381.53,205.72 3383.82,214.48 C3385.94,222.50 3391.51,238.80 3394.97,247.09 C3398.39,255.10 3405.68,268.93 3409.55,275.76 C3413.64,282.64 3422.50,296.53 3427.26,303.54 C3433.42,312.28 3443.12,324.95 3447.59,330.11 C3452.73,336.01 3463.06,346.29 3468.26,350.65 C3474.68,355.92 3488.48,364.15 3496.06,367.12 C3503.65,370.07 3515.03,372.22 3526.53,373.32 C3534.14,373.88 3549.29,374.47 3556.83,374.50 C3561.00,374.48 3579.36,372.81 3586.85,371.86 C3594.32,370.74 3609.87,367.97 3616.57,365.62 C3623.89,363.01 3638.94,354.78 3645.28,349.91 C3649.71,346.48 3661.42,335.07 3666.70,329.03 C3671.98,322.97 3680.54,311.69 3687.46,301.70 C3692.29,294.51 3701.13,280.62 3705.14,273.92 C3708.89,267.37 3715.71,254.77 3719.79,244.46 C3723.21,235.77 3727.60,220.33 3728.99,212.25 C3730.25,204.77 3731.35,191.67 3731.29,184.87 C3731.20,178.73 3727.99,163.94 3725.42,157.76 C3724.03,154.46 3720.74,148.72 3718.28,145.44 C3713.36,138.90 3701.92,127.85 3694.01,121.60 C3682.64,113.00 3653.56,93.73 3638.60,84.41 C3631.81,80.36 3618.92,72.86 3612.82,69.41 C3605.32,65.35 3588.87,58.31 3582.12,56.44 C3576.02,54.78 3563.27,54.31 3554.82,55.29 C3547.59,56.15 3533.68,59.55 3527.04,61.39 C3520.03,63.49 3504.93,68.40 3496.90,71.21 C3488.94,74.17 3473.48,80.49 3465.96,83.85 C3454.28,89.38 3448.20,92.69 3437.35,99.46 C3430.57,103.94 3417.47,113.35 3411.15,118.29 C3404.46,123.67 3394.52,134.27 3390.58,140.25 C3386.73,146.15 3383.10,154.71 3382.64,156.00 Z",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL11, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L-11.ac167fc7.svg";
export { ForwardRef as ReactComponent };